import { Injectable } from "@angular/core";
import { IdeaDateTime, IIdeaDatetimeStruct } from "@ideatech/ngx-ideatech";
import { NgbDate, NgbDateAdapter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { IWSDateTime } from "../interfaces/ws-datetime.interface";
import { WSDateTime } from "../classes/ws-datetime";

@Injectable()
export class VegaDateAdapter extends NgbDateAdapter<IWSDateTime> {

    fromModel(value: IWSDateTime | null): NgbDateStruct | null {
        let result: NgbDateStruct | null;
        const dateTime = WSDateTime.from(value);
        if (dateTime?.hasValue && dateTime?.day && dateTime?.month && dateTime?.year) {
            result = {
                day: dateTime.day,
                month: dateTime.month,
                year: dateTime.year
            }
        } else {
            result = null;
        }
        return result;
    }

    toModel(date: NgbDateStruct | null): IWSDateTime | null {
        const dateTime = WSDateTime.from(!!date ? { day: date.day, month: date.month, year: date.year, hour: 0, minute: 0, second: 0,dateStringValue: "", stringValue: "", hasValue: true } : undefined);
        return dateTime?.toObject() ?? null;
    }

}
